/* =========================================================================== *\
 __      __.__     ___________           .__    ____ ________  ________.________
/  \    /  \__| ___\__    ___/___   ____ |  |__/_   /   __   \/   __   \   ____/
\   \/\/   /  |/    \|    |_/ __ \_/ ___\|  |  \|   \____    /\____    /____  \ 
 \        /|  |   |  \    |\  ___/\  \___|   Y  \   |  /    /    /    //       \
  \__/\  / |__|___|  /____| \___  >\___  >___|  /___| /____/    /____//______  /
       \/          \/           \/     \/     \/                             \/ 
\* =========================================================================== */

import React, { createRef } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

// @mui material components
import Icon from '@mui/material/Icon';

// Material Dashboard 2 PRO React components
import MDButton from 'components/MDButton';

function QuotationFile({ uploadData }) {
  const { t } = useTranslation();
  const fileInput = createRef();

  const handleUploadFile = (e) => {
    e.preventDefault();
    const reader = new FileReader();
    const file = e.target.files[0];
    reader.onloadend = () => {
      uploadData(reader.result, file);
    };
    if (file) {
      reader.readAsDataURL(file);
    }
  };

  const handleClick = () => {
    fileInput.current.click();
  };

  return (
    <div>
      <label htmlFor='file-open'>
        <input
          ref={fileInput}
          accept='.pdf, .doc, .docx, .zip, .xls, .xlsx, .ppt, .pptx, .rar, .jpg, .png, .jpeg'
          style={{ display: 'none' }}
          type='file'
          onChange={handleUploadFile}
        />
        <MDButton variant='gradient' color='dark' onClick={handleClick}>
          <Icon>post_add</Icon>&nbsp;เลือกไฟล์
        </MDButton>
      </label>
    </div>
  );
}

QuotationFile.propTypes = {
  uploadData: PropTypes.func.isRequired,
};

export default QuotationFile;
